var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c("h2", { staticClass: "h2_title mb-1" }, [
        _vm._v("Información de Atención")
      ]),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            "mt-5": "",
            layout: "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha de Emisión", readonly: "" },
                model: {
                  value: _vm.data.atefecha_emision,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atefecha_emision", $$v)
                  },
                  expression: "data.atefecha_emision"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Número", readonly: "" },
                model: {
                  value: _vm.data.atenumero,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atenumero", $$v)
                  },
                  expression: "data.atenumero"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Nota de Venta", readonly: "" },
                model: {
                  value: _vm.data.ndvnumero,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ndvnumero", $$v)
                  },
                  expression: "data.ndvnumero"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Cliente", readonly: "" },
                model: {
                  value: _vm.data.razon_social,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "razon_social", $$v)
                  },
                  expression: "data.razon_social"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Dirección", readonly: "" },
                model: {
                  value: _vm.data.atecliente_direccion,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atecliente_direccion", $$v)
                  },
                  expression: "data.atecliente_direccion"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Comuna", readonly: "" },
                model: {
                  value: _vm.data.atecliente_comuna,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atecliente_comuna", $$v)
                  },
                  expression: "data.atecliente_comuna"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Teléfono", readonly: "" },
                model: {
                  value: _vm.data.atecliente_telefono,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atecliente_telefono", $$v)
                  },
                  expression: "data.atecliente_telefono"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Email", readonly: "" },
                model: {
                  value: _vm.data.atecliente_email,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atecliente_email", $$v)
                  },
                  expression: "data.atecliente_email"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Giro", readonly: "" },
                model: {
                  value: _vm.data.atecliente_giro,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atecliente_giro", $$v)
                  },
                  expression: "data.atecliente_giro"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Documento", readonly: "" },
                model: {
                  value: _vm.data.atedocumento_agenerar,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atedocumento_agenerar", $$v)
                  },
                  expression: "data.atedocumento_agenerar"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha INET", readonly: "" },
                model: {
                  value: _vm.data.atefecha_atencion,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atefecha_atencion", $$v)
                  },
                  expression: "data.atefecha_atencion"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Número INET", readonly: "" },
                model: {
                  value: _vm.data.atenumero_inet,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atenumero_inet", $$v)
                  },
                  expression: "data.atenumero_inet"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Estado", readonly: "" },
                model: {
                  value: _vm.data.ateestado,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ateestado", $$v)
                  },
                  expression: "data.ateestado"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Neto Productos", readonly: "" },
                model: {
                  value: _vm.data.ateneto_producto,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ateneto_producto", $$v)
                  },
                  expression: "data.ateneto_producto"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "% Descuento", readonly: "" },
                model: {
                  value: _vm.data.atedescuento_porcien,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atedescuento_porcien", $$v)
                  },
                  expression: "data.atedescuento_porcien"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Monto Descuento", readonly: "" },
                model: {
                  value: _vm.data.atedescuento_monto,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atedescuento_monto", $$v)
                  },
                  expression: "data.atedescuento_monto"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Neto Afecto", readonly: "" },
                model: {
                  value: _vm.data.ateneto_afecto,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ateneto_afecto", $$v)
                  },
                  expression: "data.ateneto_afecto"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "IVA", readonly: "" },
                model: {
                  value: _vm.data.ateiva,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ateiva", $$v)
                  },
                  expression: "data.ateiva"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Total", readonly: "" },
                model: {
                  value: _vm.data.atetotal,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atetotal", $$v)
                  },
                  expression: "data.atetotal"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Usuario Genera", readonly: "" },
                model: {
                  value: _vm.data.usuario_genera,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "usuario_genera", $$v)
                  },
                  expression: "data.usuario_genera"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Estado Transmisión", readonly: "" },
                model: {
                  value: _vm.data.ateestado_transmision,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ateestado_transmision", $$v)
                  },
                  expression: "data.ateestado_transmision"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Usuario Anula", readonly: "" },
                model: {
                  value: _vm.data.usuario_modifica,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "usuario_modifica", $$v)
                  },
                  expression: "data.usuario_modifica"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha Anula", readonly: "" },
                model: {
                  value: _vm.data.atefecha_anula,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "atefecha_anula", $$v)
                  },
                  expression: "data.atefecha_anula"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }